import pick from 'lodash/pick';
import {
    deleteValueFromStorage,
    getValueFromStorage,
    setValueToStorage
} from '~/common/hooks/useStorage';
import {
    LEAD_INFO_INPUT_NAMES,
    TLeadInfoInputNames,
    TPublicFlowSubmitData
} from '~/components/ClientExperience/OneFlow/components/FlowView/LeadFormSubmit/LeadFormSubmit.types';
import { LEAD_FORM_SESSION_STORAGE_KEY } from '~/constants/lead-forms.consts';

const commonStorageProps = {
    key: LEAD_FORM_SESSION_STORAGE_KEY,
    storage: sessionStorage
};

const deletePublicFlowSessionStorage = ({ flowId }: { flowId: string }) => {
    return deleteValueFromStorage({ ...commonStorageProps, path: flowId });
};

const deletePublicFlowSessionStorageVariable = ({
    flowId,
    variableId
}: {
    flowId: string;
    variableId: string;
}) => {
    return deleteValueFromStorage({
        ...commonStorageProps,
        path: `${flowId}.${variableId}`
    });
};

const getPublicFlowValuesFromSessionStorage = ({
    flowId
}: {
    flowId: string;
}): TPublicFlowSubmitData => {
    return getValueFromStorage({ ...commonStorageProps, path: flowId });
};

const _setPublicFlowValuesToSessionStorage = ({
    flowId,
    value
}: {
    flowId: string;
    value: Partial<TPublicFlowSubmitData>;
}) => {
    return setValueToStorage({ ...commonStorageProps, path: flowId, value });
};
const setPublicFlowVariableToSessionStorage = ({
    flowId,
    variableId,
    value
}: {
    flowId: string;
    variableId: string;
    value: any;
}) => {
    return setValueToStorage({
        ...commonStorageProps,
        path: `${flowId}.${variableId}`,
        value
    });
};

const keepOnlyPublicFlowLeadInfoToSessionStorage = ({
    flowId
}: {
    flowId: string;
}) => {
    const data = getPublicFlowValuesFromSessionStorage({ flowId });
    const pickedLeadInfoData: Pick<typeof data, TLeadInfoInputNames> = pick(
        data,
        LEAD_INFO_INPUT_NAMES
    );
    _setPublicFlowValuesToSessionStorage({ flowId, value: pickedLeadInfoData });
};

export const getLeadFormSessionStorageMethods = ({
    flowId
}: {
    flowId: string;
}) => {
    return {
        deleteSessionStorage: () => deletePublicFlowSessionStorage({ flowId }),

        deleteVariable: ({ variableId }: { variableId: string }) =>
            deletePublicFlowSessionStorageVariable({ flowId, variableId }),

        persistLeadInfo: () =>
            keepOnlyPublicFlowLeadInfoToSessionStorage({ flowId }),

        getValues: () => getPublicFlowValuesFromSessionStorage({ flowId }),

        setVariable: ({
            variableId,
            value
        }: {
            variableId: string;
            value: any;
        }) =>
            setPublicFlowVariableToSessionStorage({ flowId, variableId, value })
    };
};
